<section
    class="about-intro"
    [class.about-intro--dark]="darkBackground">

    <div class="container-redesign">

        <div class="about-intro__content">

            <h2 class="about-intro__title">
                {{ title }}
            </h2>

            <p
                *ngFor="let paragraph of paragraphs; trackBy: trackByIndex"
                class="about-intro__paragraph">

                {{ paragraph }}

            </p>

        </div>

    </div>

</section>